// https://vuex.vuejs.org/en/mutations.html

export default {
    SET_DRAWER (state, payload) {
        state.drawer = payload
    }
}